import { Action } from 'redux';
import { put } from 'redux-saga/effects';
import { BasketActionTypes, BasketActions } from '../';
import { ErrorAction } from 'store';
import { BasketSagaReturnType } from 'store/sagaHelpers';
import { basketStorage } from 'storages';
import { errorToBasketErrorModel } from 'helpers';

export interface HandleApiAuthErrorRequestAction extends Action<BasketActionTypes.HANDLE_API_AUTH_ERROR_REQUEST> {
}

export interface HandleApiAuthErrorRequestActionStart extends Action<BasketActionTypes.HANDLE_API_AUTH_ERROR_REQUEST_START> {
}

export interface HandleApiAuthErrorRequestActionSuccess extends Action<BasketActionTypes.HANDLE_API_AUTH_ERROR_REQUEST_SUCCESS> {
}

export interface HandleApiAuthErrorRequestActionError extends ErrorAction<BasketActionTypes.HANDLE_API_AUTH_ERROR_REQUEST_ERROR> {
}

export function* handleApiAuthErrorRequestSaga(): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.HANDLE_API_AUTH_ERROR_REQUEST_START,
    });

    try {
        const basket = basketStorage.getBasket();

        if (basket?.guid || basket?.entries.length) {
            yield put<BasketActions>({
                type: BasketActionTypes.SET_SHOW_SESSION_HAS_EXPIRED_WARNING,
                shouldShowSessionHasExpiredWarning: true
            });
        }

        yield put<BasketActions>({
            type: BasketActionTypes.HANDLE_API_AUTH_ERROR_REQUEST_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.HANDLE_API_AUTH_ERROR_REQUEST_ERROR,
            error: errorToBasketErrorModel(error, 'handleApiAuthErrorRequestSaga')
        });

        return false;
    }
}